var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8.5,
    stroke: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.5L9 13L14 8",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.660534e057d626a1cd4c2df29d4e8815.svg";
export { ForwardRef as ReactComponent };